import { supabase } from './supabaseClient'

// Upload a capture blob to the private `moments` bucket. The blob is
// always a canvas-encoded JPEG from MomentsCapturePage — no gallery
// path, no raw File. Canvas re-encoding has already stripped EXIF
// (including GPS), so nothing extra to do.
//
// Path shape <userId>/<promptId>.jpg — one capture per user per
// prompt by unique constraint, so the path is stable. upsert=false
// surfaces double-submits as errors instead of silently overwriting.
//
// Returns { path, error }. The hook writes the path to
// moments_captures.image_path and mints signed URLs for display
// since the bucket is private.
export async function uploadMomentImage(userId, promptId, blob) {
  if (!userId) return { path: null, error: 'missing userId' }
  if (!promptId) return { path: null, error: 'missing promptId' }
  if (!blob) return { path: null, error: 'missing blob' }

  const path = `${userId}/${promptId}.jpg`
  const { error } = await supabase.storage
    .from('moments')
    .upload(path, blob, {
      upsert: false,
      contentType: 'image/jpeg',
      cacheControl: '3600',
    })
  if (error) return { path: null, error: error.message }
  return { path, error: null }
}
